export default __webpack_public_path__ + "static/media/read_only.8d1f252c.png";